"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationProvider = void 0;
const tween_js_1 = __importDefault(require("@tweenjs/tween.js"));
const injets_1 = require("injets");
const Application_1 = require("../../engine/Application");
const pixi_viewport_1 = require("pixi-viewport");
const Culling = __importStar(require("pixi-cull"));
let ApplicationProvider = class ApplicationProvider {
    constructor() {
        this.culling = new Culling.Simple();
    }
    createApp(options) {
        this.app = new Application_1.Application(options);
        // Camera
        this.camera = this.app.camera = new pixi_viewport_1.Viewport({ divWheel: this.app.view, disableOnContextMenu: true })
            .drag({ wheelScroll: 0 })
            .wheel({ reverse: false, smooth: 10 })
            .clampZoom({ maxScale: 2, minScale: 0.5 })
            .pinch();
        //   .bounce({
        //     // @ts-ignore
        //     bounceBox: {
        //       x: bounds.left - bounds.width / 1.5,
        //       y: bounds.top - bounds.height / 4.5,
        //       width: bounds.width * 1.5,
        //       height: bounds.height / 1.5,
        //     },
        //   })
        // Camera Resize
        window.addEventListener('resize', () => {
            this.app.resize();
            if (this.camera && this.camera.visible) {
                this.camera.resize(window.innerWidth, window.innerHeight);
            }
        });
        this.app.ticker.add(() => {
            // Update tween
            tween_js_1.default.update(this.app.ticker.lastTime);
            // Cull whenever the viewport moves
            if (this.camera.dirty) {
                this.culling.cull(this.cullingBox);
                this.camera.dirty = false;
            }
        });
        // Add camera do stage
        this.app.stage.addChild(this.camera);
    }
    get cullingBox() {
        const cameraRect = this.camera.getVisibleBounds();
        const BOUND_MARGIN = 0;
        // Adiciona uma margem para o culling
        cameraRect.x -= BOUND_MARGIN;
        cameraRect.y -= BOUND_MARGIN;
        cameraRect.width += BOUND_MARGIN * 2;
        cameraRect.height += BOUND_MARGIN * 2;
        return cameraRect;
    }
};
ApplicationProvider = __decorate([
    injets_1.Provider()
], ApplicationProvider);
exports.ApplicationProvider = ApplicationProvider;
